// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1_10t","footer":"ModalCreateQualiphyProcedure_footer__3joKL","additionData":"ModalCreateQualiphyProcedure_additionData__jEnwQ"};